import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  AddDocumentLink,
  DeleteDocumentLink,
  fetchDocumentLinkAll,
  UpdateDocumentLink,
} from "../../Redux/WhatsappSlice/DocumentLinkSetup";
import WpDynamicTable from "../../Components/WhatsappTable/WpDynamicTable";
import Loader from "../../Components/Loader/Loader";

const DocumentLink_main = () => {
  const dispatch = useDispatch();

  const { DocumentLinks } = useSelector((state) => state.DocumentLinkSetup);

  const [formData, setFormData] = useState({
    DocLinkName: "",
    WHADOcLinkURL: "",
    WHADOcURLKey: "",
  });

  const [editId, setEditId] = useState(null);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(fetchDocumentLinkAll());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = (formData) => {
    const errors = {};

    if (!formData.DocLinkName || formData.DocLinkName.trim() === "") {
      errors.DocLinkName = "URL name is required";
    }

    if (!formData.WHADOcLinkURL || formData.WHADOcLinkURL.trim() === "") {
      errors.WHADOcLinkURL = "URL is required";
    }

    if (!formData.WHADOcURLKey || formData.WHADOcURLKey.trim() === "") {
      errors.WHADOcURLKey = "URL Key is required";
    }
    return errors;
  };

  const handleDelete = async (row) => {
    const isConfirmed = window.confirm(
      `Are you sure you want to delete this item?`
    );
    if (!isConfirmed) return;

    try {
      await dispatch(DeleteDocumentLink({ id: row.MainId })).unwrap();
      toast.success("Data deleted successfully!", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
      dispatch(fetchDocumentLinkAll()); // refresh list
    } catch (error) {
      toast.error(`Failed to delete Data: ${error}`, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const handleEdit = (row) => {
    setEditId(row.MainId);
    setFormData({
      DocLinkName: row.DocLinkName,
      WHADOcLinkURL: row.WHADOcLinkURL,
      WHADOcURLKey: row.WHADOcURLKey,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (Object.keys(validationErrors).length === 0) {
      try {
        if (editId) {
          await dispatch(UpdateDocumentLink({ id: editId, formData })).unwrap();
          toast.success("Data updated successfully!", {
            position: "top-right",
            autoClose: 1000,
          });
        } else {
          await dispatch(AddDocumentLink({ values: formData })).unwrap();
          toast.success("Data added successfully!!", {
            position: "top-right",
            autoClose: 1000,
          });
        }

        // Reset form
        setFormData({
          DocLinkName: "",
          WHADOcLinkURL: "",
          WHADOcURLKey: "",
        });
        dispatch(fetchDocumentLinkAll());
      } catch (error) {
        toast.error(
          `Failed to ${
            editId ? "update" : "add"
          } Whatsapp Document Link Data: ${error.message || "Unknown error"}`,
          {
            position: "top-right",
            autoClose: 1000,
          }
        );
      }
    } else {
      toast.error("Please fix validation errors.", {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
      });
    }
  };

  const columns = [
    { field: "id", headerName: "No", flex: 1 },
    {
      field: "DocLinkName",
      headerName: "Document Link Name",
      flex: 1,
    },
    { field: "WHADOcLinkURL", headerName: "Document Link URL", flex: 1 },
    { field: "WHADOcURLKey", headerName: "	Document URL Key", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <div className="flex space-x-2 justify-center">
          <button
            className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
            onClick={() => handleEdit(params.row)}
          >
            Update
          </button>
          <button
            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            onClick={() => handleDelete(params.row)}
          >
            Delete
          </button>
        </div>
      ),
    },
  ];

  const rows = (DocumentLinks || [])?.map((el, index) => ({
    id: index + 1,
    MainId: el._id,
    DocLinkName: el?.DocLinkName,
    WHADOcLinkURL: el?.WHADOcLinkURL,
    WHADOcURLKey: el?.WHADOcURLKey,
  }));

  if (!DocumentLinks ) {
    return <Loader />;
  }

  return (
    <>
      <div className="">
        <div className="title">
          <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
            {editId ? "Update Document Link" : "Add Document Link Main"}
          </h3>
        </div>

        <div className="Form_bg_color bg-white shadow-sm rounded-xl mt-4">
          <form
            onSubmit={handleSubmit}
            className="grid grid-cols-12 gap-4 p-3 rounded-2xl"
          >
            {/* Document Link Name Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Document Link Name</h5>
              <input
                type="text"
                name="DocLinkName"
                // placeholder="Enter Your Range"
                value={formData.DocLinkName}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.DocLinkName && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.DocLinkName}
                </p>
              )}
            </div>

            {/* Document Link URL Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Document Link URL</h5>
              <input
                type="text"
                name="WHADOcLinkURL"
                // placeholder="Enter Your Range"
                value={formData.WHADOcLinkURL}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.WHADOcLinkURL && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.WHADOcLinkURL}
                </p>
              )}
            </div>

            {/* WHADOcURLKey Input */}
            <div className="col-span-12 lg:col-span-4 md:col-span-6">
              <h5 className="mb-1 block font-semibold">Document URL Key</h5>
              <input
                type="text"
                name="WHADOcURLKey"
                // placeholder="Enter Your Range"
                value={formData.WHADOcURLKey}
                onChange={handleChange}
                className="bg-[#F3F8FB] w-full p-2 border-2 border-black rounded"
              />
              {errors.WHADOcURLKey && (
                <p className="text-red-500 text-sm mt-1">
                  {errors.WHADOcURLKey}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <div className="submit_Form col-span-12 flex justify-center">
              <button type="submit" className="All_button">
                {editId ? "Update" : "Submit"}
              </button>

              {editId && (
                <button
                  type="button"
                  className="bg-gray-500 text-white ms-2 px-4 py-2 rounded hover:bg-gray-600"
                  onClick={() => {
                    setFormData({
                      DocLinkName: "",
                      WHADOcLinkURL: "",
                      WHADOcURLKey: "",
                    });
                    setEditId(null);
                    setErrors({});
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </div>

        <div className="px-2 py-6">
          <div className="title">
            <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block text-uppercase rounded">
              View Document Link Setup
            </h3>
          </div>
          <div className="rounded-lg overflow-x-auto mt-3">
            <WpDynamicTable columns={columns} rows={rows} />
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentLink_main;
